import { useEffect, type ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { useMe } from "../api/hooks.ts";
import { Spinner } from "../components/ui.tsx";
import { OutfitContext } from "../art/outfitContext.ts";
import { sound } from "../lib/sound.ts";
import { ErrorScreen } from "../screens/ErrorScreen.tsx";

export function RequireParent({ children }: { children: ReactNode }) {
  const me = useMe();
  const location = useLocation();
  if (me.isPending) return <Spinner />;
  if (me.isError) return <ErrorScreen onRetry={() => void me.refetch()} />;
  if (!me.data) return <Navigate to="/dang-nhap" replace state={{ from: location.pathname }} />;
  return children;
}

const NO_OUTFIT = {};

export function RequireChild({ children }: { children: ReactNode }) {
  const me = useMe();
  // sound effects follow the active child: the parent's default, or the child's own choice (SPEC 9.6)
  const childId = me.data?.activeChildId ?? null;
  const active = me.data?.children.find((c) => c.id === childId);
  const soundDefault = active?.sound ?? true;
  useEffect(() => {
    sound.configure(childId, soundDefault);
  }, [childId, soundDefault]);
  if (me.isPending) return <Spinner />;
  if (me.isError) return <ErrorScreen onRetry={() => void me.refetch()} />;
  if (!me.data) return <Navigate to="/dang-nhap" replace />;
  if (!me.data.activeChildId) return <Navigate to="/chon-be" replace />;
  // every bee in child mode wears the child's outfit (SPEC 7.5)
  return <OutfitContext value={active?.outfit ?? NO_OUTFIT}>{children}</OutfitContext>;
}
